import {
  userIsNotConfirmed,
  userIsConfirmed,
} from './user';
import { findVariantPrice } from '../helpers/pages/collections/collectionsHelpers';
import { productIsPFL } from '../helpers/productHelpers';

export const variantDownloadAllowedFor = (
  user: any,
  collectionVariants: any,
  collectionDownload: any,
  collection: any,
): boolean => {
  if (userIsConfirmed(user)) return true;
  if (userIsNotConfirmed(user)) {
    if (productIsPFL(collection)) return false;
    const collectionVariant = collectionVariants.find(
      (variant: any) => variant.id === collectionDownload.variant_id
    );
    if (!collectionVariant) return false;
    return collectionVariant.original_price > 0;
  }
  return false;
}

export const productVariantCanBeDownloaded = (
  user: any,
  variantId: number,
  variantPrices: any,
  product: any,
): boolean => {
  if (userIsConfirmed(user)) return true;
  if (userIsNotConfirmed(user)) {
    if (productIsPFL(product)) return false;
    return !product?.free_product;
  }
  return false;
}

const contentDownloadHelpers = {
  variantDownloadAllowedFor,
  productVariantCanBeDownloaded,
};

export default contentDownloadHelpers;
